<template>
    <!--    <form ref="form" onsubmit="return false">-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">마일리지</span>
            <span class="txt">수업 결제 및 출석체크 등 회원님께 등록할 마일리지 정보에 대한 설정을 진행합니다.</span>
        </div>

        <p class="sub-title">마일리지 설정</p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">
                        이용권 결제 시
                        <small>이용권 결제 시, 결제 수단별 적립, 마일리지를 설정합니다.</small>
                    </span>
                    <div class="line">
                        <span class="tit">카드</span>
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="data.tickCardYn"
                                    :checked="!data.tickCardYn"
                                    :value="false"
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-1-2"
                                    v-model="data.tickCardYn"
                                    :checked="data.tickCardYn"
                                    :value="true"
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-2">적립률</label>
                            </div>
                            <input
                                v-model="data.ticketCardRatio"
                                :disabled="!data.tickCardYn"
                                :required="data.tickCardYn"
                                class="w80 center"
                                maxlength="3"
                                type="text"
                            />
                            <span class="txt">% 로 마일리지 적립</span>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">현금</span>
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-2-1"
                                    v-model="data.tickCashYn"
                                    :checked="!data.tickCashYn"
                                    :value="false"
                                    name="radio-2"
                                    type="radio"
                                />
                                <label for="radio-2-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-2-2"
                                    v-model="data.tickCashYn"
                                    :checked="data.tickCashYn"
                                    :value="true"
                                    name="radio-2"
                                    type="radio"
                                />
                                <label for="radio-2-2">적립률</label>
                            </div>
                            <input
                                v-model="data.ticketCashRatio"
                                :disabled="!data.tickCashYn"
                                :required="data.tickCashYn"
                                class="w80 center"
                                maxlength="3"
                                type="text"
                            />
                            <span class="txt">% 로 마일리지 적립</span>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">계좌이체</span>
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-3-1"
                                    v-model="data.tickBankYn"
                                    :checked="!data.tickBankYn"
                                    :value="false"
                                    name="radio-3"
                                    type="radio"
                                />
                                <label for="radio-3-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-3-2"
                                    v-model="data.tickBankYn"
                                    :checked="data.tickBankYn"
                                    :value="true"
                                    name="radio-3"
                                    type="radio"
                                />
                                <label for="radio-3-2">적립률</label>
                            </div>
                            <input
                                v-model="data.ticketBankRatio"
                                :disabled="!data.tickBankYn"
                                :required="data.tickBankYn"
                                class="w80 center"
                                maxlength="3"
                                type="text"
                            />
                            <span class="txt">% 로 마일리지 적립</span>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">기타</span>
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-4-1"
                                    v-model="data.tickEtcYn"
                                    :checked="!data.tickEtcYn"
                                    :value="false"
                                    name="radio-4"
                                    type="radio"
                                />
                                <label for="radio-4-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-4-2"
                                    v-model="data.tickEtcYn"
                                    :checked="data.tickEtcYn"
                                    :value="true"
                                    name="radio-4"
                                    type="radio"
                                />
                                <label for="radio-4-2">적립률</label>
                            </div>
                            <input
                                v-model="data.ticketEtcRatio"
                                :disabled="!data.tickEtcYn"
                                :required="data.tickEtcYn"
                                class="w80 center"
                                maxlength="3"
                                type="text"
                            />
                            <span class="txt">% 로 마일리지 적립</span>
                        </div>
                    </div>
                    <span class="top-title">
                        출석체크 시
                        <small>
                            회원이 터치출석 및 회원예약 어플리케이션에서 출석체크를 하는 경우, 마일리지 적립여부를
                            설정합니다. 마일리지 100원은 현금 100원과 동일한 가치를 갖습니다.
                        </small>
                    </span>
                    <div class="line">
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-5-1"
                                    v-model="data.attendanceAccmUseYn"
                                    :checked="!data.attendanceAccmUseYn"
                                    :value="false"
                                    name="radio-5"
                                    type="radio"
                                />
                                <label for="radio-5-1">사용안함</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-5-2"
                                    v-model="data.attendanceAccmUseYn"
                                    :checked="data.attendanceAccmUseYn"
                                    :value="true"
                                    name="radio-5"
                                    type="radio"
                                />
                                <label for="radio-5-2">회원이 출석체크를 할 때마다</label>
                            </div>
                            <input
                                v-model="data.attendanceAccmMilige"
                                :disabled="!data.attendanceAccmUseYn"
                                :required="data.attendanceAccmUseYn"
                                class="w80 center"
                                maxlength="10"
                                type="text"
                            />
                            <span class="txt">원의 마일리지를 적립합니다.</span>
                        </div>
                    </div>
                    <!-- <span class="top-title">적립 유지기간 <small>적립한 마일리지의 유효기간을 설정합니다. 유지기간은 각각의 적립 시점을 기준으로 유지됩니다.</small></span> -->
                    <!-- <div class="line">
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input v-model="data.accmKeepYn" :value="false" :checked="!data.accmKeepYn" type="radio" name="radio-6" id="radio-6-1">
                                <label for="radio-6-1">기간 상관없이 유지됩니다.</label>
                            </div>
                            <div class="com-radio">
                                <input v-model="data.accmKeepYn" :value="true" :checked="data.accmKeepYn" type="radio" name="radio-6" id="radio-6-2">
                                <label for="radio-6-2">마일리지 적립 유지기간은</label>
                            </div>
                            <input v-model="data.accmKeepDay" :disabled="!data.accmKeepYn" :required="data.accmKeepYn" type="text" class="w80 center" maxlength="4">
                            <span class="txt">일로 설정하며,  유지기간 이후 마일리지는 소멸됩니다.</span>
                        </div>
                    </div> -->
                    <!-- <span class="top-title">마일리지 사용제한 <small>회원이 마일리지를 사용할 경우, 일정 금액 이상부터 사용이 가능한지 또는 이와 상관없이 사용가능한지의 여부를 설정합니다.</small></span> -->
                    <!-- <div class="line">
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input v-model="data.miligeUseLockYn" :value="false" :checked="!data.miligeUseLockYn" type="radio" name="radio-7" id="radio-7-1">
                                <label for="radio-7-1">제한없음</label>
                            </div>
                            <div class="com-radio">
                                <input v-model="data.miligeUseLockYn" :value="true" :checked="data.miligeUseLockYn" type="radio" name="radio-7" id="radio-7-2">
                                <label for="radio-7-2" class="single"></label>
                            </div>
                            <input v-model="data.miligeUsePrice" :disabled="!data.miligeUseLockYn" :required="data.miligeUseLockYn" type="text" class="w80 center" maxlength="10">
                            <span class="txt">원 이상부터 사용이 가능합니다.</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn" type="button" @click="reset">취소</button>
            <button :disabled="isLoading" class="com-btn blue" type="button" @click="save">수정</button>
        </div>
    </div>
    <!--    </form>-->
</template>

<script>
import api from '../../../assets/js/api';

export default {
    name: 'SettingMileage',
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            data: {
                centerId: 0,
                tickCardYn: true,
                ticketCardRatio: 0,
                tickCashYn: true,
                ticketCashRatio: 0,
                tickBankYn: true,
                ticketBankRatio: 0,
                tickEtcYn: true,
                ticketEtcRatio: 0,
                attendanceAccmUseYn: true,
                attendanceAccmMilige: 0,
                accmKeepYn: true,
                accmKeepDay: 0,
                miligeUseLockYn: true,
                miligeUsePrice: 0,
            },
        };
    },
    mounted() {
        this.reset();
    },
    methods: {
        reset() {
            this.isLoading = true;
            api.get(`/admin/api/centerMileage/${this.centerId}`)
                .then(({ data }) => {
                    this.isLoading = false;
                    if (data) {
                        this.data = data;
                    }
                })
                .catch((res) => {
                    this.isLoading = true;
                    alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
        save(evt) {
            // if (!this.$refs.form.checkValidity()) {
            //     (this.$refs.form.querySelector(':invalid') || { focus() {} }).focus();
            //     return;
            // }

            this.isLoading = true;
            this.data.centerId = this.centerId;
            api.post('/admin/api/centerMileage', this.data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.reset();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss"></style>
